import * as React from "react";
import { CustomerFormTypeData } from "@plinknz/tah-website-elements";

import { BackToSchoolGrantForm } from "./back-to-school-grant-form";
import { CulturalGrantForm } from "./cultural-grant-form";
import { EmergencyGrantForm } from "./emergency-grant-form";
import { HauoraGrantForm } from "./hauora-grant-form";
import { MaraeForm } from "./marae-booking-form";
import { RegistrationForm } from "./registration-form";
import { SportsGrantForm } from "./sports-grant-form";
import { SymposiumGrantForm } from "./symposium-grant-form";

interface CustomerFormBlockProps {
    data: CustomerFormTypeData;
}

export const CustomerFormBlock = ({
    data: { active, type },
}: CustomerFormBlockProps) => {
    if (!active) {
        return <div data-testid="inactive-form" />;
    }

    switch (type) {
        case "cultural":
            return <CulturalGrantForm />;
        case "emergency":
            return <EmergencyGrantForm />;
        case "hauora":
            return <HauoraGrantForm />;
        case "marae":
            return <MaraeForm />;
        case "primary":
            return <BackToSchoolGrantForm />;
        case "registration":
            return <RegistrationForm />;
        case "sports":
            return <SportsGrantForm />;
        case "symposium":
            return <SymposiumGrantForm />;
        default:
            return <div data-testid="unknown-form" />;
    }
};
